import { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

import { Badge, Button, SideSectionCard, Text, spacing } from '@pletly/ui';

interface Props {
	organisationUuid: string;
	pendingInvitationsCount?: number;
}

export const ConnectionRequestsCard = ({
	organisationUuid,
	pendingInvitationsCount = 0,
}: Props) => {
	const { t } = useTranslation();
	const { navigate } = useNavigation();

	const handleViewAllPress = useCallback(() => {
		navigate('Invitations', { organisationUuid });
	}, [navigate, organisationUuid]);

	return (
		<SideSectionCard style={styles.card}>
			<Text category="h4">{t('connection-requests.title')}</Text>

			<Badge invisible={!pendingInvitationsCount} value={pendingInvitationsCount}>
				<Button variant="outline" color="primary" onPress={handleViewAllPress} size="small">
					{t('connection-requests.view-all')}
				</Button>
			</Badge>
		</SideSectionCard>
	);
};

const styles = StyleSheet.create({
	card: {
		gap: spacing(2),
		//@ts-expect-error valid on web
		flex: 'unset',
		zIndex: -1,
	},
});
